var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 15,
    viewBox: "0 0 10 15",
    fill: "#999999",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.99992 0.833313C2.41992 0.833313 0.333252 2.91998 0.333252 5.49998C0.333252 8.99998 4.99992 14.1666 4.99992 14.1666C4.99992 14.1666 9.66658 8.99998 9.66658 5.49998C9.66658 2.91998 7.57992 0.833313 4.99992 0.833313ZM1.66659 5.49998C1.66659 3.65998 3.15992 2.16665 4.99992 2.16665C6.83992 2.16665 8.33325 3.65998 8.33325 5.49998C8.33325 7.41998 6.41325 10.2933 4.99992 12.0866C3.61325 10.3066 1.66659 7.39998 1.66659 5.49998Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.a0d0e115.svg";
export { ForwardRef as ReactComponent };